import { render } from "./socialMediaView.vue?vue&type=template&id=3308f86c&scoped=true&ts=true"
import script from "./socialMediaView.vue?vue&type=script&lang=ts"
export * from "./socialMediaView.vue?vue&type=script&lang=ts"

import "./socialMediaView.vue?vue&type=style&index=0&id=3308f86c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3308f86c"]])

export default __exports__